<template>
    <ModalComponent
        :name="'anadir-subscriptor-modal'"
        :title="'Añadir suscriptor a ' + grupo.nombre"
        @close="close"
    >
        <div v-if="!finalizar">
            <div class="mb-3">
                <b-form-input
                    v-model="search"
                    type="text"
                    placeholder="Buscar por email, nombre, apellidos o teléfono"
                    class="mb-2"
                    debounce="300"
                    @update="getGrupo"
                    cols="6"
                />
            </div>
            <div v-if="loading">Cargando...</div>
            <div v-else>
                <div v-if="subscriptores.length === 0">
                    No hay suscriptores disponibles.
                </div>
                <div v-else>
                    <ul style="max-height: 300px; overflow-y: auto;">
                        <li v-for="subscriptor in subscriptores" :key="subscriptor.id">
                            <label style="display: flex; align-items: center;">
                                <b-checkbox
                                    :id="'subscriptor-' + subscriptor.id"
                                    :value="subscriptor.id"
                                    v-model="subscriptoresSeleccionados"
                                    :disabled="loading"
                                    style="margin-right: 8px;"
                                />
                                <span class="mr-2">{{ subscriptor.nombre }}</span>
                                <span class="text-muted">({{ subscriptor.email }})</span>
                            </label>
                        </li>
                    </ul>
                    <div class="mt-3 d-flex align-items-center justify-content-between">
                        <div>
                            <label for="per-page-select" class="mr-2">Elementos por página:</label>
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="[5, 10, 20, 50, 100]"
                                @change="getGrupo(1)"
                                size="sm"
                                style="width: auto; display: inline-block;"
                            />
                        </div>
                        <b-pagination
                            v-model="page"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="center"
                            @change="getGrupo"
                        />
                    </div>
                    <div class="mt-3 d-flex justify-content-between">
                        <div>
                            <b-button
                                class="mr-2"
                                variant="secondary"
                                @click="seleccionarTodos"
                                :disabled="loading || subscriptores.length === 0"
                            >
                                Seleccionar todos
                            </b-button>
                            <b-button
                                variant="secondary"
                                @click="subscriptoresSeleccionados = []"
                                :disabled="loading || subscriptoresSeleccionados.length === 0"
                            >
                                Deseleccionar todos
                            </b-button>
                        </div>
                        <b-button
                            variant="primary"
                            @click="finPasoUno"
                            :disabled="subscriptoresSeleccionados.length === 0 || loading"
                        >
                            Continuar
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="finalizar">
            <p>Suscriptores seleccionados: {{ subscriptoresSeleccionados.length }}</p>
            <ul style="max-height: 300px; overflow-y: auto;">
                <li v-for="id in subscriptoresSeleccionados" :key="id">
                    <span>
                        {{
                            subscriptores.find(sub => sub.id === id)?.nombre
                                ? subscriptores.find(sub => sub.id === id).nombre + ' (' + subscriptores.find(sub => sub.id === id).email + ')'
                                : id
                        }}
                    </span>
                </li>
            </ul>
            <b-button variant="primary" class="mr-5" :disabled="loading" @click="volver">volver</b-button>
            <b-button variant="primary" :disabled="loading" @click="terminar">Finalizar</b-button>
        </div>

    </ModalComponent>
</template>

<script>
    import ModalComponent from "../../../components/ModalComponent.vue";
    import apiService from '@/services/api-comunicados';

    export default {
        props: {
            grupo: {
                type: Object,
                required: true
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: false,
                subscriptores: [],
                subscriptoresSeleccionados: [],
                search: '',
                finalizar : false,
                perPage: 10,
                page: 1,
                totalRows: 0
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            async getGrupo(page = 1, to_select = false) {
                this.page = page;
                this.loading = true;

                var filters = {
                    grupos_ids_excluir: [this.grupo.id],
                    search: this.search,
                    page: this.page,
                    per_page: this.perPage,
                    to_select : to_select ? 'true' : 'false'
                }

                try {
                    const response = await apiService.getSubscriptores(filters);
                    this.subscriptores = response.data;
                    if(!to_select){
                        this.perPage = response.meta.per_page;
                        this.totalRows = response.meta.total;
                    }
                } catch (error) {
                    this.$toast.error('Error al obtener subscriptores', error);
                } finally {
                    this.loading = false;
                }
            },
            seleccionarTodos() {
                this.subscriptoresSeleccionados = this.subscriptores.map(sub => sub.id);
            },
            continuar() {
                this.$emit('subscriptores-seleccionados', this.subscriptoresSeleccionados);
                this.close();
            },
            finPasoUno() {
                if (this.subscriptoresSeleccionados.length > 0) {
                    this.limpiarDatos();
                    this.getGrupo(1,true).finally(() => {
                        this.finalizar = true;
                    });
                } else {
                    this.$toast.warning('Debe seleccionar al menos un suscriptor.');
                }
            },
            volver() {
                this.finalizar = false;
                this.subscriptoresSeleccionados = [];
                this.limpiarDatos();
                this.getGrupo();
            },
            async añadirSubcriptores() {
                this.loading = true;

                var data = {
                    subscriptores: this.subscriptoresSeleccionados,
                }

                try {
                    const response = await apiService.vincularSubscriptoresGrupo(this.grupo.id, data);
                    this.$toast.success('Suscriptores añadidos correctamente');
                    this.$emit('close');
                } catch (error) {
                    this.$toast.error('Error al añadir suscriptores', error);
                } finally {
                    this.loading = false;
                }
            },
            terminar() {
                this.añadirSubcriptores();
            },
            limpiarDatos() {
                this.search = '';
                this.subscriptores = [];
                this.page = 1;
                this.totalRows = 0;
                this.perPage = 10;
            }
        },
        mounted() {
            this.getGrupo();
        },
        watch: {
            show(newVal) {
                if (newVal) {
                    this.subscriptoresSeleccionados = [];
                    this.finalizar = false;
                    this.limpiarDatos();
                    this.getGrupo();
                }
            }
        },
        components: {
            ModalComponent
        }
    }

</script>